import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';

// Define the props type
interface DownloadPdfButtonProps {
    handleDownload: () => void; // Function to trigger the download
    isDownloading: boolean; // Boolean flag to indicate if downloading
    title: string; // Button title
}

const DownloadPdfButton: React.FC<DownloadPdfButtonProps> = ({ handleDownload, isDownloading, title }) => {
    return (
        <Box display="flex" flexDirection="column" alignItems="start" mb={5}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleDownload}
                startIcon={!isDownloading && <PictureAsPdfIcon />}
                disabled={isDownloading}
                sx={{
                    margin: '5px',
                    position: 'relative',
                    padding: '8px 24px',
                    backgroundColor: '#2574a9',
                    '&:hover': {
                        backgroundColor: 'rgba(37, 116, 169, 0.8)', // Red background on hover
                    },
                    '&:disabled': {
                        backgroundColor: '#d3d3d3', // Optional: gray background when disabled
                    },
                }}
            >
                {isDownloading ? (
                    <Box display="flex" alignItems="center">
                        <CircularProgress
                            size={24}
                            sx={{
                                marginRight: '8px',
                            }}
                        />
                        <Typography>{title}</Typography>
                    </Box>
                ) : (
                    title
                )}
            </Button>
        </Box>
    );
};

export default DownloadPdfButton;
